__turbopack_context__.v({
  "adBanner": "SMTqtG_adBanner",
  "article": "SMTqtG_article",
  "commentsContainer": "SMTqtG_commentsContainer",
  "commentsOverlay": "SMTqtG_commentsOverlay",
  "customBannerContainer": "SMTqtG_customBannerContainer",
  "empty": "SMTqtG_empty",
  "heading": "SMTqtG_heading",
  "layout": "SMTqtG_layout",
  "overflowContainer": "SMTqtG_overflowContainer",
  "slideInAnimation": "SMTqtG_slideInAnimation",
  "videoContainer": "SMTqtG_videoContainer",
  "visible": "SMTqtG_visible",
});
